export default __webpack_public_path__ + "static/media/postImage6.75558b86.png";